import React from 'react';
import styles from './errorLayout.module.css';

export default function Error() {
  return (
    <div className={styles['centered-column']}>
      <h2>UNABLE TO RETRIEVE ROLE, PLEASE CONTACT SUPPORT</h2>
    </div>
  );
}
